/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na rámy pro zobrazování médií,
 * které provádí skrývání pomocí pozicování rámů mimo obrazovku.
 * @implements {ViewerFrameFactory}
 */
class PositionFrameFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<PositionFrame>} PositionFrame
   * @param {CssValue} cssValue
   * @param {StateMachineFactory} stateMachineFactory
   */
  constructor(PositionFrame, cssValue, stateMachineFactory) {
    this.PositionFrame = PositionFrame;
    this.cssValue = cssValue;
    this.stateMachineFactory = stateMachineFactory;
  }

  /** @returns {PositionFrame} */
  create() {
    return new this.PositionFrame(this.cssValue, this.stateMachineFactory);
  }
}

export default PositionFrameFactory;
